import React from 'react';

export function useLocalStorageState<T>(storageKey: string, startingValue: T) {
	const storedValue = tryJsonParse(localStorage.getItem(storageKey));

	const state = React.useState<T>(
		storedValue !== undefined ? storedValue : startingValue
	);

	const [current] = state;
	React.useEffect(() => {
		localStorage.setItem(storageKey, JSON.stringify(current));
	}, [current, storageKey]);

	return state;
}

function tryJsonParse(value: unknown) {
	if (typeof value !== 'string') {
		return undefined;
	}

	try {
		return JSON.parse(value);
	} catch {
		return undefined;
	}
}
